module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAAARCAYAAADJ0RJfAAAAAXNSR0IArs4c6QAAAKRJREFUWAntmLEJgEAMRSO4hKWgu7iMAziBA7iEhQO4i4KlY+gFVK64XB3kBQ7DC4GfVypCYQADeQNXGHt+ixF/DlxfqnTH802a7avy60T2qPfYnkaow+CKdcf7XZn4jDCAAQxgAAMYwAAGMIABDGDgNwaK6JIt6j22awjVJ4KNDxsSsymwLsE9ofYNE/8OaV7o9FsZuWqDK9Yd73dl4jPCAAZEbvrXW2LruwW3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/beto1.png
// module id = 7jev
// module chunks = 1